import request from '@/utils/request'
const imgBaseURL = process.env.VUE_APP_IMG

/**
 * 上传文件 长期文件
 * @param {FormData} file
 * @returns
 */
export function uploadRepoFile(data) {
  return request({
    url: '/upload/repo/file',
    method: 'post',
    baseURL: imgBaseURL,
    params: {},
    data
  })
}

/**
 * 删除文件
 * @param {String} file_link 文件链接
 * @returns
 */
export function delRepoFile(file_link) {
  return request({
    url: '/delete/repo/file',
    method: 'post',
    baseURL: imgBaseURL,
    params: { file_link }
  })
}

/**
 * 上传文件
 * @param {String} cs_dir
 * @param {File} file
 * @param {String} subdir /xxx
 * @returns url#object_name
 */
export async function uploadOSSFile(cs_dir, file, subdir = '') {
  try {
    const filename = file.name
    const auth = await getAuthoriztion(`${cs_dir}${subdir}`)
    const formData = new FormData()
    formData.append('name', filename)
    formData.append('key', auth.dir + '${filename}')
    formData.append('policy', auth.policy)
    formData.append('OSSAccessKeyId', auth.accessid)
    formData.append('success_action_status', 200)
    formData.append('signature', auth.signature)
    formData.append('file', file)
    await request({
      url: auth.host,
      timeout: 10 * 60 * 1000,
      method: 'post',
      params: {},
      data: formData
    })
    return request({
      url: '/cs/get/aliyunoss/file/url/v2',
      baseURL: imgBaseURL,
      method: 'POST',
      params: {
        object_name: auth.dir + filename
      }
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

/**
 * 获取 OSS 文件链接
 * @param {String} url 文件链接
 * @param {String} objectName 文件 key
 * @returns {Object} {code, errMsg}
 */
export async function getOSSFileUrl(objectName) {
  try {
    // let key = ''
    // if (objectName) {
    //   key = objectName
    // } else {
    //   const expires = url.split(/[?&]/).find((item) => item.includes('Expires'))
    //   const expireTime = Number(expires.split('=').pop())
    //   const nowTime = parseInt(new Date().getTime() / 1000)
    //   if (expireTime - nowTime > 3600) {
    //     return Promise.resolve(url)
    //   }
    //   key = url.split('#').pop()
    // }
    // console.log("Requesting URL with baseURL:", imgBaseURL);
    const res = await request({
      url: '/cs/get/aliyunoss/file/url/v2',
      baseURL: imgBaseURL,
      method: 'POST',
      params: {
        object_name: objectName
      }
    })
    // console.log(`get oss url resp:`, res)
    if (res.code === 0) {
      return Promise.resolve(res.desc)
    }
    return Promise.resolve(res.desc)
  } catch (err) {
    console.error('Error in get oss url:', err, `object_name:`, objectName)
    return Promise.resolve(objectName)
  }
}

/**
 * 删除文件
 * @param {String} object_name
 * @returns
 */
export function removeOSSFile(object_name) {
  return request({
    url: '/cs/remove/custom/oss/file/v2',
    method: 'post',
    baseURL: imgBaseURL,
    params: {
      object_name: object_name.split('#').pop()
    }
  })
}

/**
 * 上传图片验证
 * @param {String} cs_dir dir | dir/xxx
 * @returns
 */
function getAuthoriztion(cs_dir) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cs/get/aliyun/oss/authoriztion/v2',
      method: 'GET',
      baseURL: imgBaseURL,
      params: {
        cs_dir
      }
    })
      .then((res) => {
        if (res.accessid) {
          resolve(res)
        } else {
          reject(res.desc)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * 上传文件
 * @param {File} file
 * @param {String} subdir /xxx
 * @returns {String} object_name
 */
export async function uploadOSSFileV2(file, subdir = '') {
  try {
    const filename = file.name
    const auth = await getAuthoriztion(`${process.env.VUE_APP_TYPE}${subdir}`)
    const formData = new FormData()
    formData.append('name', filename)
    formData.append('key', auth.dir + '${filename}')
    formData.append('policy', auth.policy)
    formData.append('OSSAccessKeyId', auth.accessid)
    formData.append('success_action_status', 200)
    formData.append('signature', auth.signature)
    formData.append('file', file)
    await request({
      url: auth.host,
      timeout: 10 * 60 * 1000,
      method: 'post',
      params: {},
      data: formData
    })
    return Promise.resolve(auth.dir + filename)
  } catch (err) {
    return Promise.reject(err)
  }
}
